import React, { useEffect } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { makeStyles } from '@material-ui/styles'
import { Typography, Button, useTheme, useMediaQuery } from '@material-ui/core'

import { Page } from 'components'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    paddingTop: '10vh',
    display: 'flex',
    height: '100vh',
    flexDirection: 'column',
    alignContent: 'center'
  },
  imageContainer: {
    marginTop: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center'
  },
  image: {
    maxWidth: '100%',
    width: 560,
    maxHeight: 300,
    height: 'auto'
  },
  buttonContainer: {
    marginTop: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center'
  }
}))

const AccessDenied = () => {
  const classes = useStyles()
  const theme = useTheme()
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'))

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Page className={classes.root} title="Evento não encontrado!">
      <Typography align="center" variant={mobileDevice ? 'h3' : 'h1'}>
        Opss! Nenhum evento localizado...
      </Typography>
      <Typography align="center" variant="subtitle2">
        Esse evento não existe, ou pode não estar disponível no momento!
      </Typography>
      <div className={classes.imageContainer}>
        <img
          alt="evento-não-encontrado!"
          className={classes.image}
          src="/images/event-not-found.svg"
        />
      </div>
      <div className={classes.buttonContainer}>
        <Button
          color="primary"
          component={RouterLink}
          to="/home"
          variant="outlined"
        >
          Voltar para home
        </Button>
      </div>
    </Page>
  )
}

export default AccessDenied
